<template>
   <div>
       
       <div class="about-main">
           <div class="title">AboutUs</div>
           
           <div class="about-card">
               <div class="topquote" id=""></div><div class="topquote" id=""></div><br>
               <p>
                <b>CodeGill</b> offers a wide spectrum of programming language courses along 
                with dedicated mentors that provide guidance in the related language and
                help you learn and build projects of your own. How do we, at <b>CodeGill</b>,
                achieve this? We provide end-to-end mentoring to our learners. What does this entail? Well, our journey starts from making
                learners understand the programming concepts more easily, guiding them to learn, 
                teaching them efficient ways to code, analyze problem sets, building projects, and last but
                not the least implementing an effective teaching and mentoring environment where 
                learners can effectively communicate with mentors and other fellow members tailoring 
                to learner’s success. When there is a strong will coupled with talent, 
                commitment, dedication, and an intense passion to see a smile on every learner's 
                face, you undoubtedly find yourself on a fairyland.
                </p>
                <div class="bottomquote" id=""></div><div class="bottomquote" id=""></div><br>
           </div>

       </div>
            <TeamCards/>
       <Footer/>
       <div class="dj-shaders">
            </div>
   </div> 
</template>

<script>

import Footer from '../general/Footer'
import TeamCards from '../general/TeamCards'
export default {
    name:'AboutUs',
    components:{
        
        Footer,
        TeamCards
    }
}
</script>

<style scoped>
    body{
    overflow-x: hidden;
    }
    .about-main{
        margin-top: 4rem;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .dj-shaders{
        bottom: 0;
        width: 100%;
        position: fixed;
        height: 1rem;
        background-color: white;
        border-radius:5rem 5rem 0 0 ;
        box-shadow: 0 1rem 1rem 2rem rgb(255, 255, 255);
        
    }
    .title{
        font-family:'Chelsea Market', cursive;
        font-size: 3em;
        text-shadow: 0.1rem 0.1rem #7367c1;
    }
    .about-card{
        margin: 2rem;
        width: 70%;
        font-family:'Josefin Sans', sans-serif;
        font-size: 1.4em;
        line-height: 1.5;
        padding: 1.5rem;
        background-color: #201e1e;
        color: white;
        border-radius:0.4rem;
        box-shadow:0.3rem 0.3rem #7e70d4;
    }
    .topquote{
        width:1.5rem;
        height:1.5rem;
        margin: 0.2rem;
        float: left;
        border-radius: 50%;
        border-bottom-right-radius: 0;
        background-color: #7e70d4;
    }
    .bottomquote{
        width:1.5rem;
        height:1.5rem;
        margin:0.2rem;
        float: right;
        border-radius: 50%;
        border-top-left-radius: 0;
        background-color: #7e70d4;
    }

@media screen and (max-width:768px){
    .about-main{
        margin-top: 7.5rem;
    }
    .about-card{
        font-size: 1em;
    }
}

</style>